import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, HostListener } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { SkeletonModule } from 'primeng/skeleton';

import { BehaviorSubject } from 'rxjs';
import { MarkdownPipe } from '../../../filters/markdown.pipe';

@Component({
  selector: 'client-migration-tab',
  templateUrl: './client-migration-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SkeletonModule,
    MarkdownPipe,
    TranslateModule,
  ]
})
export class ClientMigrationTabComponent implements OnInit {
  @Input('clientId') clientId: number = 0;
  showSkeleton = new BehaviorSubject<boolean>(false);
  activeTab: string = 'migration';
  clientMigration: any;

  constructor(
    private store: Store,
    private activatedRouter: ActivatedRoute,
    private clientService: ClientService,
    private toastMessageService: ToastMessageService,
    private fb: UntypedFormBuilder,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getClientMigrations();
  }

  @HostListener('window:visibilitychange', ['$event'])
  VisibilityChange(event: any): void {
    if (event.target.visibilityState.toLowerCase() == 'visible') {
      this.getClientMigrations();
    }
  }

  getClientMigrations() {
    this.clientId = this.activatedRouter.snapshot?.params['clientid']
      ? this.activatedRouter?.snapshot?.params['clientid']
      : this.clientId;
    this.clientService.getMigrationData(this.clientId).subscribe({
      next: (response: any) => {
        this.showSkeleton.next(false);
        this.clientMigration = response;
      },
      error: (error) => {
        this.showSkeleton.next(false);
        this.translate
        .get('MIGRATION.ERROR_MSG')
        .subscribe((translation) => {
        this.toastMessageService.showErrorMessage(translation);
      });
      },
    });
  }
}
